import React, { FC } from 'react'
import ErrorMessage, { ErrorMessageProps } from './ErrorMessage'

import { ReactComponent as Logo } from 'icons/logo.svg'

const Generic: FC<Partial<ErrorMessageProps>> = props => (
  <ErrorMessage {...(props as ErrorMessageProps)} />
)

Generic.defaultProps = {
  title: 'Something went wrong',
  /* "iconSize" is not a known property of SVG logos so needs to be extracted */
  icon: function Icon({ iconSize, ...props }) {
    return <Logo width="46px" height="46px" {...props} />
  },
  iconSize: 'small',
  description: (
    <>
      We’re aware of the issue and will fix it as soon as possible. You can find
      more information on our{' '}
      <a href="https://status.sketch.com/">Status Page</a>.
    </>
  ),
}

export default Generic
